import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=70b8fc88&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=70b8fc88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8fc88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b8fc88')) {
      api.createRecord('70b8fc88', component.options)
    } else {
      api.reload('70b8fc88', component.options)
    }
    module.hot.accept("./ContactDetails.vue?vue&type=template&id=70b8fc88&scoped=true&", function () {
      api.rerender('70b8fc88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ContactDetails.vue"
export default component.exports